module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("食宿人数" + _vm._s(_vm.sai_member_count) + "人")]), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": "根据您这里填写的食宿人数配发餐券和乘坐大巴，请您认真核对!"
    }
  }), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "领队",
      "value": _vm.row.lingdui_shisu_count
    }
  }, [_c('van-stepper', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.row.lingdui_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "lingdui_shisu_count", $$v)
      },
      expression: "row.lingdui_shisu_count"
    }
  })], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "运动员",
      "value": _vm.row.yundongyuan_shisu_count
    }
  }, [_c('van-stepper', {
    attrs: {
      "min": _vm.row.yundongyuan_count
    },
    model: {
      value: (_vm.row.yundongyuan_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "yundongyuan_shisu_count", $$v)
      },
      expression: "row.yundongyuan_shisu_count"
    }
  })], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "教练员",
      "value": _vm.row.jiaolian_shisu_count
    }
  }, [_c('van-stepper', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.row.jiaolian_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "jiaolian_shisu_count", $$v)
      },
      expression: "row.jiaolian_shisu_count"
    }
  })], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "随行人员",
      "value": _vm.row.suixing_shisu_count
    }
  }, [_c('van-stepper', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.row.suixing_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "suixing_shisu_count", $$v)
      },
      expression: "row.suixing_shisu_count"
    }
  })], 1), _vm._v(" "), (_vm.row.saiqu.userdiydate == 1) ? _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "入住/离开酒店日期",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        _vm.dateShow = true
      }
    }
  }, [_vm._v(" \n                " + _vm._s(_vm.row.date_range[0])), _c('br'), _vm._v(_vm._s(_vm.row.date_range[1]) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('van-calendar', {
    attrs: {
      "default-date": _vm.formData.date_range,
      "type": "range"
    },
    on: {
      "confirm": _vm.onDateConfirm
    },
    model: {
      value: (_vm.dateShow),
      callback: function($$v) {
        _vm.dateShow = $$v
      },
      expression: "dateShow"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep2',
        query: {
          id: this.$route.query.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep2',query:{id:this.$route.query.id}}"
    }],
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "native-type": "button"
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "保存中...",
      "native-type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.formData.need_shisu = 2
      }
    }
  }, [_vm._v("不要食宿")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.formData.need_shisu = 1
      }
    }
  }, [_vm._v("保存并选择食宿\n                ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04792473","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep3.vue
// module id = 2159
// module chunks = 0